import Log from './log';

const regex =
  /^(?=[a-zA-Z0-9_+-]{1,}[a-zA-Z0-9_+-.]{1,})([a-zA-Z0-9_+-]+(?:\.[a-zA-Z0-9_+-]+)*)@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

export function validateEmail(input: string): boolean {
  return regex.test(input);
}

export function validatePhone(input: string): boolean {
  // eslint-disable-next-line no-useless-escape
  return /^[ \+\(\)\-0-9]+$/.test(input);
}

export function plusPrefixPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber.startsWith('+')) {
    return `+${phoneNumber}`;
  }
  return phoneNumber;
}

export function isHttps(url: string): boolean {
  try {
    // Parse and validate the url using the URL object
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol === 'https:') {
      return true;
    }
    Log.error(`URL failed protocol validation: ${url}`);
    return false;
  } catch (error) {
    // The URL is invalid or cannot be parsed
    return false;
  }
}

/**
 * Returns a sanitized cdn url ensuring a https protocol and known hostname.
 * Fragments and query parameters are removed.
 */
export function sanitizeCdnUrl(url: string | URL): URL | undefined {
  // Whitelisted CDN domains
  const validDomains = [
    'https://cdn-alpha.smartmedialabs.io',
    'https://cdn-beta.smartmedialabs.io',
    'https://cdn.smartmedialabs.io',
  ];

  // Construct URL objects
  const inputURL = typeof url === 'string' ? new URL(url) : url;
  const validDomainURLs = validDomains.map((base) => new URL(base));

  // Check if the input url has a valid protocol and domain
  const trustedURL = validDomainURLs.find(
    (cdnURL) => cdnURL.protocol === 'https:' && cdnURL.hostname === inputURL.hostname,
  );

  if (!trustedURL) {
    return undefined;
  }

  // Build a new URL, use only the hostname and path components of the input url
  return new URL(inputURL.pathname, `https://${inputURL.hostname}`);
}
